import React, { createContext, useContext, useState, useEffect } from "react";

const OrthotimgerContext = createContext(null);

const STORAGE_KEY = "orthotimer_patient";

const defaultData = {
  patientId: "",
  firstName: "",
  lastName: "",
  birthday: "",
  source: "",
  selectedVersionId: null,
};

export const OrthotimgerProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? { ...defaultData, ...JSON.parse(stored) } : { ...defaultData };
    } catch {
      return { ...defaultData };
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }, [data]);

  const clearOrthotimer = () => setData({ ...defaultData });

  return (
    <OrthotimgerContext.Provider value={{ data, setData, clearOrthotimer }}>
      {children}
    </OrthotimgerContext.Provider>
  );
};

export const useOrthotimer = () => {
  const ctx = useContext(OrthotimgerContext);
  if (!ctx) throw new Error("useOrthotimer must be used within OrthotimgerProvider");
  return ctx;
};
